/**
 * @ngdoc Directive
 * @name vrm-dropdown
 * @example
 *
 * <vrm-dropdown />
 *
 */
import Tether from 'tether';

(function () {
    'use strict';

    angular.module('vrm.components')
        .constant('vrmDropdownEvent', {
            'toggle': 'vrmDropdownEvent.toggle'
        })
        .directive('vrmDropdown', vrmDropdown);

    /* @ngInject */
    function vrmDropdown($rootScope, vrmDropdownEvent, $document) {

        var definition = {
            scope: {
                id: '@'
            },
            restrict: 'E',
            transclude: true,
            template: require('@/angular/modules/vrm-components/dropdown/dropdown.template.html'),
            link: link
        };

        return definition;

        /**
         * Link
         * @param $scope
         * @param $element
         * @param $attr
         */
        function link($scope, $element, $attr) {
            $scope.tether = null;
            $scope.element = $element.find('.vrm-dropdown');
            $scope.customClass = $attr.customClass;

            var openOnTrigger = $attr.openOnTrigger || 'click';
            var closeOn = $attr.closeOn;

            var triggerElement = null;


            var toggleEvent = $rootScope.$on(vrmDropdownEvent.toggle, function (event, data) {

                // Don't act on messages for other dropdowns
                if (data.id !== $scope.id) return;

                if (data.eventType === openOnTrigger && !$scope.element.hasClass('active')) {
                    triggerElement = data.target;
                    openDropdown();
                } else {
                    closeDropdown();
                }
            });


            var eventHandler = function (event) {
                if (closeOn && event.type == closeOn) {
                    closeDropdown();
                }
            };

            $scope.element.on('mouseenter mouseleave click', eventHandler);

            $scope.$on('$destroy', function () {
                if ($scope.tether != null) {
                    $scope.tether.destroy();
                }

                // Clean up event handlers
                $scope.element.off();

                // Remove the click listener for closing the popup.
                $document.off('click', onClick);

                //Remove toggle listener
                toggleEvent();

                //Remove the element as it has been moved by Tether
                $scope.element.remove();
            });

            function closeDropdown() {
                $scope.element.removeClass('active');

                if (triggerElement != null) {
                    triggerElement.blur();
                }

                if ($scope.tether != null) {
                    $scope.tether.destroy();
                }

                $document.off('click', onClick);
            }

            function openDropdown() {
                if (triggerElement != null) {
                    triggerElement.focus();
                }

                $scope.element.addClass('active');

                if ($scope.tether != null) {
                    $scope.tether.destroy();
                }

                $scope.tether = new Tether({
                    element: $scope.element,
                    target: triggerElement,
                    attachment: 'top center',
                    targetAttachment: 'bottom center',
                    targetOffset: '10px 0',
                    constraints: [{
                        to: 'window',
                        pin: ['left', 'right']
                    }]
                });

                $scope.tether.enable();
                $scope.tether.position();

                $document.on('click', onClick);
            }

            /**
             * Check if a click event is within the getBoundingClientRect of the popup menu.
             *
             * @param element
             * @param event
             * @returns {boolean}
             */
            function contains(element, event) {
                if ($scope.tether) {
                    const rect = $scope.tether.element.getBoundingClientRect();

                    const matchX = event.clientX > rect.left && event.clientX < rect.right;
                    const matchY = event.clientY > rect.top && event.clientY < rect.bottom;

                    return matchX && matchY;
                }

                return false;
            }

            /**
             * Handle clicks on the entire page to check if we have to close the modal because the user clicked
             * outside of it.
             *
             * @param event
             */
            function onClick(event) {
                const exactTriggerMatch = triggerElement && event.target === triggerElement[0];

                // For some dropdown buttons, the triggerElement becomes the custom component (e.g. vrm-icon-button), while
                // the click event target gets the proper HTML node as value (e.g. <a> instead of vrm-icon-button).
                // To catch this we check if the triggerElement contains that HTML node as a child.
                const containsTrigger = triggerElement && triggerElement[0] && triggerElement[0].contains(event.target);

                if (exactTriggerMatch || containsTrigger) {
                    // Ignore click events on the trigger element to prevent the popup from closing immediately.
                    return;
                }

                if ($scope.tether && $scope.element.hasClass('active') && !contains($scope.element, event)) {
                    closeDropdown();
                }
            }
        }
    }
})();
